import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './businessForm.schema';

import {
  hideBusinessModalForAdd,
  saveBusiness,
} from './store/actions';

import {
  isSavingBusinessInProgressSelector,
  businessCodeOptionsSelector,
} from './store/selectors';

import { OptionsPropTypes } from '../customGroupsPage/propTypes';

const ModalTitles = {
  ADD: 'Add Business Code',
};

class AddBusinessModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    saveBusiness: PropTypes.func.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    onAfterSave: PropTypes.func.isRequired,
    businessCodeOptions: OptionsPropTypes,
  };

  save = (businessData, { setSubmitting, resetForm }) => {
    const { saveBusiness, onAfterSave } = this.props;

    saveBusiness({ businessData }, () => {
      resetForm();
      onAfterSave();
    });
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      hideModal,
      isVisible,
      isSavingInProgress,
      businessCodeOptions,
    } = this.props;

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-business-modal"
        title={ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={formik.handleSubmit}
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={false}
          formContext={
            businessCodeOptions
          }
        />
      </Modal>
    );
  };

  render() {
    const {
      businessCodeOptions,
    } = this.props;

    return (
      <FormikProvider
        schema={schema}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{ businessCodeOptions }}
      />
    );
  }
}

const mapStateToProps = state => ({
  isSavingInProgress: isSavingBusinessInProgressSelector(state),
  businessCodeOptions: businessCodeOptionsSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideModal: hideBusinessModalForAdd,
    saveBusiness,
  }
)(AddBusinessModal);
